import headerImg from '../../../assets/developers/devbanner.svg'

import ease from '../../../assets/developers/ease.svg'
import growth from '../../../assets/developers/growth.svg'
import speed from '../../../assets/developers/speed.svg'

import whyChoose from '../../../assets/developers/whyChoose.svg'


export const headerData = {
    title: 'Nodejs',
    title2: 'Developers',
    desc: 'Node.js developers are professionals who specialize in building web applications using Node.js, a popular JavaScript runtime environment. They are proficient in server-side programming with Node.js and are capable of creating scalable, high-performance web applications using frameworks such as Express.js.',
    points: [
        'Quick deployment',
        'An active community with open-source solutions',
        'Shorter time-to-market circle',
    ],
    img: headerImg
}

export const achiveData = {
    title1: 'What can you Achieve with the right',
    title2: 'Node.js Developers?',
    desc: "You need a Node.js team that never compromises on your project’s success determinants. Let's find out what a field-proven team looks like",
    cards: [
        {
            title: 'Growth with Confidence',
            desc: 'Start small but go big with CodeZone’s Node.js developers, who leverage seamless and cost-effective cloud computing tools to expand your user base.',
            img: ease
        },
        {
            title: 'Ease of Flexibility',
            desc: 'Node-to-node technology facilitates Node.js developers to smoothly integrate changes without altering the core programming source, contributing to easier maintenance.',
            img: growth
        },
        {
            title: 'Speed and Performance',
            desc: 'Node.js experts integrate uninterrupted speed and performance to handle high traffic, making Node.js an ideal framework for developing user-centric apps.',
            img: speed
        },


    ]
}

export const partnerData = {
    title1: 'Partner With CodeZone for Future-forward',
    title2: 'Node JS App Development Services',

    cards: [
        {
            title: 'Truly Agile Procedures',
            desc: "CodeZone's Node.js developers follow the time-tested agile practices throughout the software development life cycle — ensuring efficiency and transparency.",
        },
        {
            title: 'Custom Node.js development services',
            desc: 'CodeZone is a houseful of Node JS experts and tech stack that fit faultlessly with your product and company culture.',
        },
        {
            title: 'Market competitive Rates',
            desc: "We provide silicon-valley level Node.js experts under budget-friendly pricing. With us, you wouldn't have to worry about your budget and the quality, because we care for both.",
        },
        {
            title: 'Dedicated Node JS Mobile App Development Teams',
            desc: "The dedicated development team co-acts with your in-house team. Borders, languages, or cultures never stop us from delivering a global enterprise-level product.",
        },


    ]
}

export const whyChooseData = {
    title: 'NodeJS',
    desc: 'Easy. Awesome. Powerful. Fast. Flexible. Fun. – All under Node.js Umbrella.',
    img: whyChoose,
    cards: [
        {
            title: 'High Performance',
            desc: 'Outperform the competition with the single-threaded and event-driven architecture of Node.js.'
        },
        {
            title: 'Easy Scalability',
            desc: 'Handle a huge number of concurrent connections and develop lightweight systems with Node.js.'
        },
        {
            title: 'Microservices',
            desc: 'Build powerful microservice-based web applications with Node.js developers.'
        },
        {
            title: 'Custom Software Development',
            desc: 'Leverage built-in API through Node.js as it can be easily extended and customized.'
        },
        {
            title: 'Fast Time-to-Market',
            desc: 'Speed up the development process with multiple frameworks and libraries of Node.js.'
        },
        {
            title: 'Community Support',
            desc: 'Expect extensive support from hawk-eyed developers of the Node.js community.'
        },
    ]
}

export const HowToData = {
    title : 'Node.js developers',
    desc : 'A meticulous process for impeccable product launch without any delays',
}

export const FAQData = [
    {
        question: ' How much will it cost to hire a NodeJS developer from CodeZone?',
        answer: 'The cost to hire Node Js developers from CodeZone varies from project to project. It depends on the project scope, time duration, services, requirements, technology stack, professional skills, selected engagement model, and other aspects.'
    },
    {
        question: 'What applications can be developed through Node.js framework?',
        answer: "Node.js is a runtime environment that allows JavaScript code to be executed. It's a strong tool for creating a variety of applications such as real-time chatbots, streaming platforms, CRM tools, single-page applications, eCommerce platforms, and more."
    },
    {
        question: 'How much does it cost to outsource the project to a Node.JS web development company?',
        answer: 'Every NodeJS development services provider company has its own cost models for Node.JS applications development. You can request the tentative cost of the project to get an idea of the final amount and how it will be paid.'
    },
    {
        question: ' Are Node JS developers in demand?',
        answer: 'Node JS is a desirable option for most Javascript developers. Android app with Node JS as well as iOS applications. Node JS engineers are in demand for their expertise and skills in creating fast, real-time and event-driven applications.'
    },

]